import { PILLAR_FORMAT_MIN } from "@growth/schema";

export type PillarDraft = { name: string; format: string; on: boolean };

/** What's missing from a ticked pillar before it can be added (null when it's ready). */
export const pillarProblem = (pillar: PillarDraft) => {
  if (!pillar.on) return null;
  if (pillar.name.trim().length < 2) return "Give it a name.";
  if (pillar.format.trim().length < PILLAR_FORMAT_MIN) return "Needs a sentence.";
  return null;
};

/** Ways a post in a pillar can work. Varied, so five pillars don't get five identical lines. */
const SHAPES = [
  (topic: string) => `Answer one question people ask about ${topic}, with a real example.`,
  (topic: string) => `Share one practical tip about ${topic}, step by step.`,
  (topic: string) => `Bust one common myth about ${topic}, and show what works instead.`,
  (topic: string) => `Tell one short story about ${topic}: what happened and what to learn.`,
  (topic: string) => `Show one before-and-after about ${topic}, and what made the difference.`,
];

/**
 * A starter sentence for a pillar, built from its name, for people who aren't sure what to
 * write. "Finding first customers" → "Answer one question people ask about finding first
 * customers, with a real example." Acronyms keep their capitals ("AI tools" stays "AI tools").
 */
export const pillarExample = (name: string, index: number) => {
  const topic = name.trim().replace(/[.!?]+$/, "");
  const lower = /^[A-Z][a-z]/.test(topic) ? topic[0]!.toLowerCase() + topic.slice(1) : topic;
  return SHAPES[index % SHAPES.length]!(lower || "this theme");
};
